import React from 'react'

export const FdContext = React.createContext({})

export const useFdContext = () => React.useContext(FdContext)